export default __webpack_public_path__ + "assets/xero_logo.4f5e344c.png";